import { useMemo } from 'react';
import { ListSelect, OnChangeHandler } from '../../formElements';
import { getEventResourceListVariables, parseListOption } from './utils';
import { ResourceComponentProps } from './types';
import { fetchListsQuery } from './graphql';

export const ResourceListSelect = ({ onChange, listType, ...props }: ResourceComponentProps) => {
  const variables = useMemo(() => getEventResourceListVariables({ listType }), [listType]);

  const handleChange: OnChangeHandler = (_val, { option }) => {
    // Fixes WF-2231
    // TODO: Look further into why this is being triggered in the first place
    if (option) {
      onChange({
        ...option,
        label: `${option.label}`,
      });
    }
  };

  return (
    <ListSelect
      data-formfieldtype="select"
      data-selectoptiontype="list"
      parseOption={parseListOption}
      {...props}
      isMulti={false}
      listType={listType}
      fetchAllItemsQuery={fetchListsQuery}
      fetchAllItemsVariables={variables}
      onChange={handleChange}
      isFullWidth
    />
  );
};
